import React, { useRef, useEffect } from 'react';
import { TRANSITIONAL_BLOCKS } from '../../constants/constants';
const QuickTipsBlock = (props) => {

    // const ref = useRef(null);
    return (<div className="tips-wrap tips-wrap-block">
        <div className="tips" dangerouslySetInnerHTML={{ __html: TRANSITIONAL_BLOCKS[props.section] }}>
        </div>
    </div>);
}

export default QuickTipsBlock;
